<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

defineOptions({
  name: 'Loading',
});

const store = useStore();
const isLoading = computed(() => store.getters.isLoading);
</script>
<template>
  <div v-if="isLoading" id="loading"></div>
</template>
<style lang="scss">
#loading {
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: fixed;
  opacity: 00;
  text-align: center;
}
</style>
